import { related, sourceIds } from './abilities__ground-slam-vs-push.mdx';

export { sourceIds, related };
export const table = {
  headers: ['比较重点', '玩法方向', '选择前核对'],
  rows: [
    ['Ground Slam', '空中接近与落点攻击', '适合主动接敌，需要安排落点'],
    ['Push', '推开目标，整理战斗空间', '适合需要控制距离和敌人位置'],
  ],
};
export const quickAnswer =
  '偏主动进攻、喜欢空中接近与落点攻击，可优先考虑 Ground Slam；更喜欢远程控制、直接击退和整理空间，则选择 Push。这是操作取向建议，不是伤害测试。';

## 两种能力怎么比较

Dancer 分组的关键是你希望如何改变接敌方式。空中动作与推开目标服务于不同的站位需求，不能仅用一个未经实测的伤害数值决定。

## Ground Slam 适合谁

若你愿意从空中发起动作，并习惯安排落点，可以考虑 Ground Slam。把位置和动作时机纳入整套配装，而不是孤立看待一次攻击。

## Push 适合谁

若你经常需要制造空间或调整敌人位置，可以考虑 Push。它的控制思路可以补充贴身武器或其他能力的节奏。

## 更换前先记录

在[配装规划器](/build-planner)记录两套方案。游戏内使用 The Gap 的Mural（重置入口）时，需要核对 Reset Item；网站清除选择不会消耗游戏资源。
